import(/* webpackMode: "eager" */ "/var/www/appagent/src/app/(landing)/about/page.tsx");
